import { NavLink, Outlet, useParams } from "react-router-dom";
import { useAppStore } from "../../store/useAppStore";
import { Badge } from "../ui";
import { formatDateBR } from "../../lib/formatters";
export function ProjectLayout() {
  const { projectId = "" } = useParams();
  const project = useAppStore((state) =>
    state.projects.find((item) => item.id === projectId),
  );
  const client = useAppStore((state) =>
    state.clients.find((item) => item.id === project?.clientId),
  );
  if (!project)
    return (
      <div className="empty-state">
        <h2>Obra não encontrada</h2>
        <p>Ela pode ter sido removida do ambiente local.</p>
      </div>
    );
  const tabs = [
    ["resumo", "Resumo"],
    ["cronograma", "Cronograma"],
    ["atividades", "Atividades"],
    ["financeiro", "Financeiro"],
    ["equipe", "Equipe"],
    ["diario", "Diário"],
    ["fotos", "Fotos"],
    ["documentos", "Documentos"],
    ["historico", "Histórico"],
  ];
  return (
    <div>
      <header className="project-header">
        <div className="project-header__identity">
          <span>{project.code}</span>
          <h1>{project.name}</h1>
          <p>{project.address}</p>
        </div>
        <div className="project-header__meta">
          <span>
            <small>Cliente</small>
            <strong>{client?.name}</strong>
          </span>
          <span>
            <small>Responsável</small>
            <strong>{project.owner}</strong>
          </span>
          <span>
            <small>Início</small>
            <strong>{formatDateBR(project.startDate)}</strong>
          </span>
          <span>
            <small>Entrega</small>
            <strong>{formatDateBR(project.endDate)}</strong>
          </span>
          <Badge tone={project.status === "Atenção" ? "warning" : "success"}>
            {project.status}
          </Badge>
        </div>
      </header>
      <nav className="tabs project-tabs">
        {tabs.map(([path, label]) => (
          <NavLink key={path} to={`/obras/${projectId}/${path}`}>
            {label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
